import { render, staticRenderFns } from "./Perfil.vue?vue&type=template&id=97a681e6&lang=pug"
import script from "./Perfil.vue?vue&type=script&lang=js"
export * from "./Perfil.vue?vue&type=script&lang=js"
import style0 from "./Perfil.vue?vue&type=style&index=0&id=97a681e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports